let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Kg3S")).then(() => parcelRequire('4tTm9'));